import csv from 'csvtojson/v2'
//const csvFileUrl='https://docs.google.com/spreadsheets/d/e/2PACX-1vT2JG5jSYdbA1LC3TCXr4H9kyhrkWT6YXyCA74Gmt1W5ciAoMHt4t_1MTb_MN2OS01KM4r-CHruFFMw/pub?gid=831930748&single=true&output=csv'

const csvFileUrl='https://docs.google.com/spreadsheets/d/e/2PACX-1vRMxKlNFR0kV1LnkmcCHwrYJoi84jt3wBSYM8QjaH5yo900XJELK37To5Ot74yIcg/pub?gid=760592434&single=true&output=csv'

export default function getFechas() {
  return fetch(csvFileUrl)
  .then(response => response.text())
  .then(data => csv().fromString(data))
  .then(function(result){
    return result
  })
}